export const LOAD_MORE_ARTICLES_REQUEST = 'LOAD_MORE_ARTICLES_REQUEST'
export const LOAD_MORE_ARTICLES_SUCCESSFUL = 'LOAD_MORE_ARTICLES_SUCCESSFUL'
export const LOAD_MORE_ARTICLES_ERROR = 'LOAD_MORE_ARTICLES_ERROR'

export const loadMoreArticles = () => {
    return {type: LOAD_MORE_ARTICLES_REQUEST}
}


// WEBPACK FOOTER //
// ./src/actions/articles.js